import React from "react";

import { PageTemplateContext } from "features/users/contexts";

export function usePageTemplate() {
  return React.useContext(PageTemplateContext)
}